import React from "react";

export default function Rules(props) {
    return (
        <div>

        </div>
    )
}